function parseTimeLabel(timeStr) {
  if (!timeStr || typeof timeStr !== "string") return "";
  const parts = timeStr.split(":");
  if (parts.length < 2) return "";
  const hours = parseInt(parts[0], 10);
  const minutes = parseInt(parts[1], 10);
  if (Number.isNaN(hours) || Number.isNaN(minutes)) return "";
  const meridiem = hours >= 12 ? "PM" : "AM";
  const hour12 = hours % 12 === 0 ? 12 : hours % 12;
  return `${hour12}:${String(minutes).padStart(2, "0")} ${meridiem}`;
}

function formatSalonHoursHint(salonHours) {
  if (!salonHours) return "";
  if (salonHours.is_closed) {
    return "Open hours for this day: Closed.";
  }
  const openLabel = parseTimeLabel(salonHours.open_time);
  const closeLabel = parseTimeLabel(salonHours.close_time);
  if (!openLabel || !closeLabel) return "";
  return `Open hours for this day: ${openLabel} – ${closeLabel}.`;
}

function includesOutsideHoursSignal(value) {
  if (!value) return false;
  const text = String(value).toUpperCase();
  return (
    text.includes("OUTSIDE_SALON_HOURS") ||
    text.includes("SALON_CLOSED") ||
    text.includes("OUTSIDE_BUSINESS_HOURS")
  );
}

export function getPreviewStatusMessage({
  reason,
  message,
  conflicts = [],
  salonHours,
}) {
  const reasonText = String(reason || "").toUpperCase();
  const hasOutsideHours =
    includesOutsideHoursSignal(reason) ||
    includesOutsideHoursSignal(message) ||
    conflicts.some((conflict) =>
      includesOutsideHoursSignal(conflict?.detail || conflict?.reason)
    );

  if (hasOutsideHours) {
    return {
      title: "Outside salon hours",
      message:
        "This time is outside the salon's business hours. Please choose a time during open hours.",
      hint: formatSalonHoursHint(salonHours),
    };
  }

  if (reasonText.includes("PAST_APPOINTMENT_NOT_ALLOWED")) {
    return {
      title: "Time in the past",
      message:
        "Selected time is in the past. Please choose a future date and time.",
      hint: "",
    };
  }

  if (reasonText.includes("NOT_WORKING")) {
    return {
      title: "Not working",
      message:
        "This technician is not scheduled to work at that time. Please choose another time or technician.",
      hint: "",
    };
  }

  if (reasonText.includes("OUTSIDE_WORKING_HOURS")) {
    return {
      title: "Technician unavailable",
      message:
        "This technician is not scheduled to work at that time. Please choose another time or technician.",
      hint: "",
    };
  }

  if (
    String(reason || "").includes("CONFLICT") ||
    conflicts.length > 0
  ) {
    return {
      title: "Time not available",
      message:
        "This technician already has an appointment at that time. Please choose another time or technician.",
      hint: "",
    };
  }

  if (message) {
    return {
      title: "Not available",
      message,
      hint: "",
    };
  }

  return {
    title: "Not available",
    message: "Please choose another time.",
    hint: "",
  };
}
